<template>
  <TextField
    v-if="showInput"
    :class="item.id"
    :disabled="isReadOnlyDialog"
    :rules="[(v) => isInvalidAgainstCommonRules() || isInvalidDecimal(v)]"
    @keydown.enter.prevent
    ref="input"
  />
</template>

<script>
import TextField from '@wizer/core/components/text-field/TextField'
import { mapState } from 'vuex'
import Cleave from 'cleave.js'
import _ from 'lodash'
import NumberFormatMixin from '@/mixins/NumberFormatMixin'
import SustainabilityInputMixin from '@/mixins/SustainabilityInputMixin'

export default {
  name: 'DecimalInput',
  mixins: [SustainabilityInputMixin, NumberFormatMixin],
  components: {
    TextField,
  },
  props: {
    isReadOnlyDialog: Boolean,
    item: Object,
    previouslySaved: Boolean,
    contextValidationMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cleave: null,
    }
  },
  mounted() {
    this.formValues[this.item.id] = this.getLocalizedInputValue(this.inputValue)

    this.cleave = new Cleave(
      `.${this.item.id} .w-text-field__input`,
      this.getCleaveOptions(this.$profile.locale, this.onValueChanged),
    )
  },
  methods: {
    updateValue(value) {
      this.showInput = false
      this.formValues[this.item.id] = value
      this.$refs.input.validate()
      this.$nextTick(() => {
        this.showInput = true
      })
    },
    onValueChanged(maskedValue) {
      this.formValues[this.item.id] = maskedValue.target.rawValue
      this.$refs.input.validate()
    },
    inputRequiresInitialAdjustment() {
      return true
    },
    isInvalidDecimal(str) {
      if (this.contextValidationMessage) {
        return this.contextValidationMessage
      }
      const parsedNumber = this.parseNumberString(str, this.$profile.locale)
      if (!_.isNumber(parsedNumber)) {
        return this.$t('validation.invalidDecimal')
      }
      let isPrecisionKept = false
      try {
        // math.js is using decimal.js to build a BigNumber, we're piggy backing on the decimal.js
        // constructor here to detect invalid decimals.
        isPrecisionKept = this.isPrecisionKeptAfterSaving(parsedNumber.toString())
      } catch (e) {
        return this.$t('validation.invalidDecimal')
      }
      if (!isPrecisionKept) {
        return this.$t('validation.invalidDecimal')
      }
      return true
    },
  },
  computed: {
    inputValue() {
      return this.formValues[this.item.id]
    },
    ...mapState({
      formValues: (state) => state.SustainabilityData.formValues,
    }),
    inputValueToPost() {
      return {
        inputValue: this.getGlobalizedInputValue(this.inputValue),
        adjusted: true,
      }
    },
  },
}
</script>
